// tslint:disable
/**
 * Document number generator API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { NumberSequenceCreateAllOf } from './number-sequence-create-all-of';
import { NumberSequenceEdit } from './number-sequence-edit';

/**
 * 
 * @export
 * @interface NumberSequenceCreate
 */
export interface NumberSequenceCreate {
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceCreate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceCreate
     */
    type: NumberSequenceCreateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceCreate
     */
    format: string;
    /**
     * 
     * @type {number}
     * @memberof NumberSequenceCreate
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof NumberSequenceCreate
     */
    strategy?: NumberSequenceCreateStrategyEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NumberSequenceCreateTypeEnum {
    Unset = 'unset',
    Contract = 'contract',
    Act = 'act',
    Bill = 'bill',
    LearningRequest = 'learning_request',
    FinalDocument = 'final_document',
    EducationProtocol = 'education_protocol',
    EnrollmentOrder = 'enrollment_order',
    ExpulsionOrder = 'expulsion_order'
}
/**
    * @export
    * @enum {string}
    */
export enum NumberSequenceCreateStrategyEnum {
    Day = 'day',
    Month = 'month',
    Year = 'year'
}



